/** @format */

import React from "react";
import CountUp from "react-countup";

function About() {
  return (
    <>
      {/* Page Header Start */}
      <div className="container-fluid page-header py-5 mb-5">
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">
            About Us
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Pages
                </a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                About
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}
      {/* Feature Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={3453} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Happy Customers</h5>
              <span>
                "I was so impressed with the quality of your product and the
                level of customer service I received. I will definitely be
                recommending your business to my friends and family." - John
                Smith
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-check text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={4234} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Project Done</h5>
              <span>
                1. The goals of the project and whether they were achieved.{" "}
                <br />
                2. The challenges that were faced and how they were overcome.{" "}
                <br />
                3. The impact of the project on the stakeholders and the
                community. <br />
                4. The lessons learned from the project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-award text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={3123} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Awards Win</h5>
              <span>
                1. The name of the award and the organization that presented it.{" "}
                <br />
                2. What the award is for. <br />
                3. Why your company or project was chosen for the award. <br />
                4. The impact of the award on your company or project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users-cog text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={1831} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Expert Workers</h5>
              <span>
                John Smith is a senior engineer at our company with over 20
                years of experience in the field of renewable energy. He has
                worked on a wide range of projects, from small-scale residential
                solar systems to large-scale commercial wind farms. John is an
                expert in all aspects of renewable energy, from design and
                engineering to installation and maintenance.
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Feature Start */}
      {/* About Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 ps-lg-0 wow fadeIn"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/about.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
            <div
              className="col-lg-6 about-text py-5 wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-lg-5 pe-lg-0">
                <h6 className="text-primary">About Us</h6>
                <h1 className="mb-4">
                  25+ Years Experience In Solar &amp; Renewable Energy Industry
                </h1>
                <p>
                  We are a leading provider of renewable energy solutions,
                  committed to providing our customers with the best possible
                  service and a sustainable future.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are a leading provider of renewable energy solutions.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are committed to providing our customers with the best
                  possible service.
                </p>
                <p>
                  <i className="fa fa-check-circle text-primary me-3" />
                  We are committed to a sustainable future.
                </p>
                <a href className="btn btn-primary rounded-pill py-3 px-5 mt-3">
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
      {/* Team Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Team Member</h6>
            <h1 className="mb-4">Experienced Team Members</h1>
          </div>
          <div className="row g-4">
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-1.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Rohan</h5>
                  <span>Designation - Field Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-2.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Jack</h5>
                  <span>Designation - Civil Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-3.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Raj</h5>
                  <span>Designation - Electrical Designer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Team End */}
    </>
  );
}

export default About;
